var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    style: {
      enableBackground: "new 0 0 51 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M34.865,51h-16.73C14.194,51,11,47.806,11,43.865V7.135C11,3.194,14.194,0,18.135,0h16.73 C38.806,0,42,3.194,42,7.135v36.73C42,47.806,38.806,51,34.865,51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283238"
    },
    d: "M37.505,42H15.495C14.67,42,14,41.33,14,40.505V8.495C14,7.67,14.67,7,15.495,7h22.009 C38.33,7,39,7.67,39,8.495v32.009C39,41.33,38.33,42,37.505,42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283238"
    },
    d: "M30,5h-3c-0.552,0-1-0.447-1-1s0.448-1,1-1h3c0.552,0,1,0.447,1,1S30.552,5,30,5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283238"
    },
    d: "M23,5c-0.26,0-0.52-0.11-0.71-0.29C22.11,4.52,22,4.26,22,4c0-0.271,0.11-0.521,0.29-0.71 c0.37-0.37,1.04-0.37,1.42,0C23.89,3.479,24,3.74,24,4s-0.11,0.52-0.29,0.71C23.52,4.89,23.26,5,23,5z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#283238"
    },
    cx: 26.5,
    cy: 46.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB6BB"
    },
    d: "M10,9C9.448,9,9,8.553,9,8V7c0-0.553,0.448-1,1-1s1,0.447,1,1v1C11,8.553,10.552,9,10,9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB6BB"
    },
    d: "M10,13c-0.552,0-1-0.447-1-1v-1c0-0.553,0.448-1,1-1s1,0.447,1,1v1C11,12.553,10.552,13,10,13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB6BB"
    },
    d: "M10,17c-0.552,0-1-0.447-1-1v-1c0-0.553,0.448-1,1-1s1,0.447,1,1v1C11,16.553,10.552,17,10,17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546A79"
    },
    d: "M17,20c0.256,0,0.512-0.098,0.707-0.293l2-2c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0 l-2,2c-0.391,0.391-0.391,1.023,0,1.414C16.488,19.902,16.744,20,17,20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546A79"
    },
    d: "M17,15c0.256,0,0.512-0.098,0.707-0.293l4-4c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0 l-4,4c-0.391,0.391-0.391,1.023,0,1.414C16.488,14.902,16.744,15,17,15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546A79"
    },
    d: "M20.29,14.29C20.11,14.479,20,14.74,20,15s0.11,0.52,0.29,0.71C20.48,15.89,20.74,16,21,16 c0.26,0,0.52-0.11,0.71-0.29C21.89,15.52,22,15.26,22,15s-0.11-0.521-0.29-0.71C21.34,13.92,20.67,13.92,20.29,14.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546A79"
    },
    d: "M22.293,13.707C22.488,13.902,22.744,14,23,14s0.512-0.098,0.707-0.293l3-3 c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0l-3,3C21.902,12.684,21.902,13.316,22.293,13.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546A79"
    },
    d: "M25.293,14.293l-9,9c-0.391,0.391-0.391,1.023,0,1.414C16.488,24.902,16.744,25,17,25 s0.512-0.098,0.707-0.293l9-9c0.391-0.391,0.391-1.023,0-1.414S25.684,13.902,25.293,14.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546A79"
    },
    d: "M27.29,12.29C27.11,12.479,27,12.74,27,13s0.11,0.52,0.29,0.71C27.48,13.89,27.74,14,28,14 c0.26,0,0.52-0.11,0.71-0.29C28.89,13.52,29,13.26,29,13s-0.11-0.521-0.29-0.71C28.34,11.92,27.67,11.92,27.29,12.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546A79"
    },
    d: "M31.707,9.293c-0.391-0.391-1.023-0.391-1.414,0l-1,1c-0.391,0.391-0.391,1.023,0,1.414 C29.488,11.902,29.744,12,30,12s0.512-0.098,0.707-0.293l1-1C32.098,10.316,32.098,9.684,31.707,9.293z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.f90b3a143f0d24c71120f79eef727a75.svg";
export { ForwardRef as ReactComponent };